import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { catchError } from 'rxjs';
import { CommonService } from 'src-adisco/services/common.service';
import { DynamicDocumentService } from 'src/app/shared/services/dynamic-document.service';

@Component({
  selector: 'app-slide-news',
  templateUrl: './slide-news.component.html',
  styleUrls: ['./slide-news.component.css'],
})
export class SlideNewsComponent implements OnInit {
  @Input() listNewsInput: any[] = [];
  responsiveOptions!: any[];
  visible: boolean = false;
  isLoadingNewsDetail = false;
  newsDetail: any;

  constructor(
    private _activeRouter: ActivatedRoute,
    private _commonService: CommonService,
    private dynamicDocumentService: DynamicDocumentService
  ) { }

  ngOnInit() {
    this.setResponsive();
  }
  setResponsive(): void {
    this.responsiveOptions = [
      {
        breakpoint: '1199px',
        numVisible: 2,
        numScroll: 2,
      },
      {
        breakpoint: '991px',
        numVisible: 2,
        numScroll: 2,
      },
      {
        breakpoint: '767px',
        numVisible: 1,
        numScroll: 1,
      },
    ];
  }
  showDialog(news: any) {
    this.newsDetail = news;
    this.visible = true;

    const documentId = this.newsDetail?.linkToResources?.[0]?.documentId;
    if (documentId) {
      this.isLoadingNewsDetail = true;
      this.dynamicDocumentService
        .findById('dynamic_ressource', documentId).pipe(catchError((err) => {
          this.isLoadingNewsDetail = false;
          throw err;
        }))
        .subscribe((res: any) => {
          this.newsDetail.file = res;
          this.isLoadingNewsDetail = false;
        });
    }
  }

  public onDownload(event: any): void {
    event.preventDefault();
    event.stopPropagation();

    if (!this.newsDetail || !this.newsDetail.file || !this.newsDetail.file.file || !this.newsDetail.file.file[0]?.url) {
      return;
    }

    let fileName: string = this.newsDetail?.file?.file?.[0]?.url;
    fileName = fileName.substring(fileName.indexOf('/resource-files/') + '/resource-files/'.length);
    fileName = fileName.substring(0, fileName.indexOf('?'));

    if (this.hasUuid(fileName)) {
      fileName = fileName.substring(fileName.indexOf('_') + 1);
    }
    fileName = decodeURIComponent(fileName).toUpperCase().replace(/ /g, '-');
    fileName = fileName.replace(/["'&=$€*\/+\[\]{}|]/g, '-');

    this._commonService.downloadFile(this.newsDetail?.file?.file?.[0]?.url, fileName);
  }

  private hasUuid(fileName: string): boolean {
    const uuid: string = fileName.substring(0, fileName.indexOf('_'));
    return (uuid.match(/-/g) || []).length === 4;
  }
}
